import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=20392c44&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=js&"
export * from "./productList.vue?vue&type=script&lang=js&"
import style0 from "./productList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productList.vue?vue&type=style&index=1&id=20392c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20392c44",
  null
  
)

export default component.exports